var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-invite-form" },
    [
      _c(
        "modal",
        {
          attrs: {
            title: "Inviter un utilisateur",
            size: "md",
            "ok-text": "Envoyer invitation",
            "cancel-text": "Annuler"
          },
          model: {
            value: _vm.opened,
            callback: function($$v) {
              _vm.opened = $$v
            },
            expression: "opened"
          }
        },
        [
          _c("form", [
            _c(
              "div",
              [
                _c("label", { attrs: { for: "" } }, [_vm._v("Utilisateur")]),
                _vm._v(" "),
                _c("select-2", {
                  ref: "select-2",
                  staticClass: "mx-1",
                  attrs: {
                    placeholder: "Choisir un utilisateur",
                    endpoint: _vm.userSelect2Endpoint,
                    dropdownParent: ".modal-invite-form .modal-dialog",
                    attributes: { chatroom_id: _vm.chatroom.chatroom_id }
                  },
                  on: {
                    selected: function($event) {
                      return _vm.userSelected($event)
                    }
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "btn",
                {
                  on: {
                    click: function($event) {
                      _vm.opened = false
                    }
                  }
                },
                [_vm._v("Annuler")]
              ),
              _vm._v(" "),
              _c(
                "btn",
                {
                  attrs: { type: "primary", disabled: _vm.confirming },
                  on: { click: _vm.confirm }
                },
                [_vm._v("Envoyer invitation")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }